import React, { useEffect, useState } from "react";
import "../style.css";
import Nav from "../components/navbar";
import Toptitle from "../components/pagetop";
import Stepper from "../components/stepper";
import { StepperControl } from "../components/stepperControl";
import ArtInfo from "../components/ArtInfo";
import ArtContext from "../components/ArtContext";
import UploadTumbnail from "../components/UploadTumbnail";
import UploadPDF from "../components/UploadPdf";
import Posted from "../components/Posted";
import { StepperContext } from "../context/StepperContext";
import { motion } from "framer-motion";
import { db } from "../firebase-config";
import { UserAuth } from "../context/authContext";
import { addDoc, doc, setDoc, Timestamp } from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Newpost() {
  /**current step index state**/
  const [currentStep, setCurrentStep] = useState(1);

  const { user } = UserAuth();

  /**where all the data concerning the post will be stored**/
  const [postData, setPostData] = useState({
    title: "",
    caption: "",
    category: "",
    tumbnailURL: "",
    content: "",
    pdfURL: "",
    pdfName: "",
  });

  /***if each step's form is validated the state is going to turn to true***/
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(true);
  const [step4, setStep4] = useState(true);
  const [finished, setFinished] = useState(false);

  /**steps title**/
  const steps = [
    "Article's info",
    "Upload tumbnail",
    "Upload PDF",
    "Article's content",
    "Published",
  ];

  /**figuring out in which index each component will be displayed**/
  const displaySteps = (step) => {
    switch (step) {
      case 1:
        return <ArtInfo />;
      case 2:
        return <UploadTumbnail />;
      case 3:
        return <UploadPDF />;
      case 4:
        return <ArtContext />;
      case 5:
        return <Posted />;
      default:
        return <ArtInfo />;
    }
  };

  /**** handle the next and back buttons to navigate through the components ****/
  const handleClick = (direction) => {
    if (
      (currentStep === 1 && step1 === true) ||
      (currentStep === 2 && step2 === true) ||
      (currentStep === 3 && step3 === true) ||
      (currentStep === 4 && step4 === true)
    ) {
      let newStep = currentStep;

      direction === "next" ? newStep++ : newStep--;

      newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
    }
  };

  /***** create a random id for the post id ******/
  function makeid(length) {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  /**changing state of step1 based on postData values**/
  useEffect(() => {
    console.log(postData);
    if (postData.title !== "" && postData.category !== "") {
      setStep1(true);
    } else {
      setStep1(false);
    }
  }, [postData]);

  const DBinsertion = () => {
    const catRef = doc(db, "users", user.uid, "Categories", postData.category);

    setDoc(catRef, {
      dummyField: makeid(3),
    });

    const postID = makeid(8);

    const count = "count";

    const postsCountDocRef = doc(
      db,
      "users",
      user.uid,
      "Categories",
      postData.category,
      "Posts",
      postID,
      "postComments",
      count
    );
    setDoc(postsCountDocRef, {
      count: 0,
    });

    try {
      const postRef = doc(
        db,
        "users",
        user.uid,
        "Categories",
        postData.category,
        "Posts",
        postID
      );
      setDoc(postRef, {
        caption: postData.caption,
        title: postData.title,
        content: postData.content,
        datePublished: Timestamp.fromDate(new Date()),
        tumbnailURL: postData.tumbnailURL,
        pdfURL: postData.pdfURL,
        category: postData.category,
        publishedBy: user.uid,
        pdfName: postData.pdfName,
        commentsCount: 0,
        postID: postID,
      });

      console.log("successfully added");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (postData.content !== "") {
      setStep3(true);
    }
  }, [step3]);

  useEffect(() => {
    if (
      postData.content !== "" &&
      postData.content.length >= 1000 &&
      finished
    ) {
      DBinsertion();
      setCurrentStep(5);
    }
  }, [postData, finished]);

  useEffect(() => {
    if (currentStep === 3) {
      toast.info(
        "You won't be able to go back from the next step to edit informations!"
      );
    }
  }, [currentStep]);

  useEffect(() => {
    if (currentStep === 4) {
      setStep4(false);
    }
  }, [currentStep]);

  return (
    <div className="mainWrapper">
      <Nav />
      <div className="innerwrapper bgNewPost overflow-hidden p-0">
        <Toptitle title="Post new article" bg="transparent" />
        <div className="h-full">
          <motion.div
            className="mx-56 mb-3  h-[73%] px-7 py-5 bg-Darkbg rounded-lg boxShadow"
            animate={{ opacity: 1, scale: 1 }}
            initial={{ opacity: 0, scale: 0.8 }}
            transition={{ ease: "easeOut", duration: 0.4, delay: 0.3 }}
          >
            <StepperControl
              handleClick={handleClick}
              currentStep={currentStep}
              steps={steps}
            />
            <StepperContext.Provider
              value={{
                postData,
                setFinished,
                setPostData,
                step1,
                setStep1,
                step2,
                setStep2,
                step3,
                setStep3,
              }}
            >
              {displaySteps(currentStep)}
            </StepperContext.Provider>
          </motion.div>
          <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 100 }}
            transition={{ ease: "easeOut", duration: 0.3 }}
          >
            <Stepper steps={steps} currentStep={currentStep} />
          </motion.div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        theme="dark"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        closeButton={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
